import React, {useEffect, useState} from 'react';


import MoverTemplate from './MoverTemplate';
import CustomerTemplate from './CustomerTemplate';

function TemplatePage(props) {

    return (
        <>
            {props.templateData.type === "mover" &&
            <MoverTemplate templateData={props.templateData} setIsTemplateOpen={props.setIsTemplateOpen}/>
            }
             {props.templateData.type === "customer" &&
           <CustomerTemplate templateData={props.templateData} setIsTemplateOpen={props.setIsTemplateOpen}/>
            }
        </>

    );
};


export default TemplatePage;
